import moment from 'moment';
import { connect } from "react-redux";
import _ from 'lodash';
import React, {Component, Fragment} from 'react';
import ViewHeader from '../view-header';
import DatePicker from 'react-datepicker';
import ReactToPrint from 'react-to-print';
import ReactTooltip from 'react-tooltip';
import { Card, DropdownItem, DropdownMenu, Row, Dropdown, DropdownToggle } from 'reactstrap';
import Pagination from "rc-pagination";
import {getDailyReportData, updateReportNotes, exportDoc, getAllDailyReportData} from "./actions";
import Notice from "../../../../components/Notification/newNotification";
import { globals } from '../../../../../../common/constants';
import { getDefaultFilters } from './helpers';

//Icons
import IconSpinner from 'react-icons/lib/fa/spinner';
import {CustomInputFilter} from "../../../../components/CustomInput";
import ViewToPrint from "../../../../components/DailyReport/ViewToPrint";

class dailyReport extends Component {
    constructor(props) {
        super(props);
        let locationState = this.props.history.location.state;
        const locationStateDefaults = getDefaultFilters();
        locationState = _.assign(locationStateDefaults, locationState);
        let startDate = locationState.filterData.filterOptions.startDate;
        let endDate = locationState.filterData.filterOptions.endDate;
        const isChecked = !!(locationState.filterData.filterOptions.endDate);
        this.state = {
            viewToPrint:false,
            reportsPerPage: globals.reportsPerPage,
            openDatePicker: false,
            isChecked,
            typeFilter: ['', 'Prototype', 'Zirconia', 'Ceramic', 'Temp', 'Other'],
            statusFilter: ['', 'Pending','Overdue','Scheduled','Received','Ready','Rejected','Archived','On hold'],
            dropdownOpen: false,
            fileType: '',
            filterData: {
                getAllReports: true,
                page: locationState.filterData.page,
                filterOptions: {
                    ...locationState.filterData.filterOptions,
                    startDate: startDate,
                    endDate: endDate && endDate
                },
                sortingOptions: locationState.filterData.sortingOptions
            },
            focusedField: null,
        };
    }

    componentDidMount() {
        document.title = "Report";
        const { page, filterOptions, sortingOptions, getAllReports } = this.state.filterData;
        filterOptions.startDate = moment(filterOptions.startDate).format('YYYY-MM-DD');
        const endDate = moment(filterOptions.endDate);
        filterOptions.endDate = endDate.isValid() ? endDate.format('YYYY-MM-DD'): null;
        this.props.getDailyReportData(page, filterOptions, sortingOptions);
        this.props.getAllDailyReportData(page, filterOptions, sortingOptions,getAllReports);
    }

    handleChangeStartDate = (date) => {
        let startDate = date;
        let endDate = moment(this.state.filterData.filterOptions.endDate);
        if (endDate && endDate < startDate) {
            let temp = startDate;
            startDate = endDate;
            endDate = temp;
        }
        this.setState({
            filterData: {
                ...this.state.filterData,
                filterOptions: {
                    ...this.state.filterData.filterOptions,
                    startDate: startDate.format('YYYY-MM-DD'),
                    endDate: endDate.isValid() && endDate.format('YYYY-MM-DD')
                },
                page: 1
            }
        }, () => {
            const { page, filterOptions, sortingOptions,getAllReports } = this.state.filterData;
            this.props.getDailyReportData(page, filterOptions, sortingOptions);
            this.props.getAllDailyReportData(page, filterOptions, sortingOptions,getAllReports);
        })
    }

    handleChangeEndDate = (date) => {
        let endDate = moment(date).endOf('day');
        let startDate = moment(this.state.filterData.filterOptions.startDate).endOf('day');
        if (endDate < startDate) {
            let temp = startDate;
            startDate = endDate;
            endDate = temp;
        }
        this.setState({
            filterData: {
                ...this.state.filterData,
                filterOptions: {
                    ...this.state.filterData.filterOptions,
                    startDate: startDate.format('YYYY-MM-DD'),
                    endDate: endDate.isValid() && endDate.format('YYYY-MM-DD')
                },
                page: 1
            }
        }, () => {
            const { page, filterOptions, sortingOptions, getAllReports } = this.state.filterData;
            this.props.getDailyReportData(page, filterOptions, sortingOptions);
            this.props.getAllDailyReportData(page, filterOptions, sortingOptions,getAllReports);
        })
    }

    handleClickCheckBox = () => {
        if (this.state.filterData.filterOptions.endDate) {
            this.setState({
                isChecked: !this.state.isChecked,
                filterData: {
                    ...this.state.filterData,
                    filterOptions: {
                        ...this.state.filterData.filterOptions,
                        endDate: undefined
                    },
                    page: 1
                }
            }, () => {
                const { page, filterOptions, sortingOptions } = this.state.filterData;
                this.props.getDailyReportData(page, filterOptions, sortingOptions);
            });
        } else {
            this.setState(prevState => ({
                isChecked: !prevState.isChecked,
            }));
        }
    }

    refreshReport = () => {
        const { page, filterOptions, sortingOptions } = this.state.filterData;
        this.props.getDailyReportData(page, filterOptions, sortingOptions);
    }

    remainDefault = (e) => {
        e.stopPropagation();
        e.preventDefault();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.reportData.addedReportNote && !this.props.reportData.addedReportNote) {
            Notice.addNotification('Notes successfully updated.', 'success');
        } else if (nextProps.reportData.addedReportNote === false) {
            Notice.addNotification('Something went wrong while saving notes.', 'error');
            const { page, filterOptions, sortingOptions } = this.state.filterData;
            this.props.getDailyReportData(page, filterOptions, sortingOptions);
        }
        if (nextProps.reportData.exportedDoc === true && !this.props.reportData.exportedDoc) {
            const link = document.createElement('a');
            link.setAttribute('target', '_blank');
            link.href = nextProps.reportData.doc;
            link.setAttribute('download', 'daily_report.' + this.state.filetype);
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
        }
    }


    handleClickOnRow = (id) => {
        console.log(this.state.filterData.filterOptions.startDate);
        this.props.history.push({
            pathname: '/sm-admin/case-details/' + id,
            state: {
                page: '/sm-admin/daily-report',
                pageName: 'Daily Report',
                filterData: {
                    filterOptions:{
                        startDate: this.state.filterData.filterOptions.startDate,
                        endDate: this.state.filterData.filterOptions.endDate && this.state.filterData.filterOptions.endDate,
                    },
                    page: this.state.filterData.page,
                    sortingOptions: this.state.filterData.sortingOptions
                }
            }
        });
    }

    handleBlur = (e, bookingId) => {
        const reportNote = e.target.value;
        if (reportNote) {
            this.props.updateReportNotes(bookingId, reportNote);
        }
    }

    handleFilter = (e) => {
        const field = e.target.name;
        const value = field === 'type' || field === 'status' ? e.target.value.toLowerCase() : e.target.value;
        this.filter(field, value);
    }

    handleSort = (field, order) => {
        this.setState({
            filterData: {
                ...this.state.filterData,
                sortingOptions: {
                    [field]: order
                },
                page: 1
            }
        }, () => {
            const { page, filterOptions, sortingOptions } = this.state.filterData;
            this.props.getDailyReportData(page, filterOptions, sortingOptions);
        });
    }

    handlePageChange = (page) => {
        this.setState({
            filterData: {
                ...this.state.filterData,
                page
            }
        }, () => {
            const { page, filterOptions, sortingOptions } = this.state.filterData;
            this.props.getDailyReportData(page, filterOptions, sortingOptions);
        })
    }

    handleExport = (filetype) => {
        this.setState({ filetype });
        this.props.exportDoc(filetype, this.state.filterData.filterOptions);
    }

    toggle = () => {
        this.setState(prevState => ({
            dropdownOpen: !prevState.dropdownOpen
        }));
    }

    openDropRow = (cell) => {
        if(this.state.dropRowId === cell) {
            this.setState({dropRowId:null});
        } else {
            this.setState({dropRowId:cell});
        }

    }

    setFocusedField = (fieldName) => {
        this.setState({ focusedField: fieldName });
    }

    filter = (fieldName, value) => {
        this.setState({
            filterData: {
                ...this.state.filterData,
                filterOptions: {
                    ...this.state.filterData.filterOptions,
                    [fieldName]: value
                },
                page: 1
            }
        }, () => {
            const { page, filterOptions, sortingOptions } = this.state.filterData;
            this.props.getDailyReportData(page, filterOptions, sortingOptions);
        });
    }

    render() {
        const header = 'DAILY REPORTS';
        const desc = 'The list of reports';
        const navBig = document.body.clientWidth > globals.NAV_MIDDLE;
        const mobileTableRender = () => {
            return (
                <table className="table table-display daily-mobile-table">
                    <thead>
                    <tr>
                        <th className="header-position">
                            <div className="sorting">
                                <span className="th-name">Dentist</span>
                                <div className="sorting__icons">
                                    <button
                                        onClick={() => this.handleSort('dentist_fullname', 'asc')}
                                        className="btn-link sort-down">
                                        <span className="kr kr-sorting-down" />
                                    </button>
                                    <button
                                        onClick={() => this.handleSort('dentist_fullname', 'desc')}
                                        className="btn-link sort-up">
                                        <span className="kr kr-sorting-up" />
                                    </button>
                                </div>
                            </div>
                        </th>
                        <th className="header-position">
                            <div className="sorting">
                                <span className="th-name">Patient</span>
                                <div className="sorting__icons">
                                    <button
                                        onClick={() => this.handleSort('patient_fullname', 'asc')}
                                        className="btn-link sort-down">
                                        <span className="kr kr-sorting-down" />
                                    </button>
                                    <button
                                        onClick={() => this.handleSort('patient_fullname', 'desc')}
                                        className="btn-link sort-up">
                                        <span className="kr kr-sorting-up" />
                                    </button>
                                </div>
                            </div>
                        </th>
                        <th className="header-position">
                            <div className="sorting">
                                <span className="th-name">Case ID</span>
                                <div className="sorting__icons">
                                    <button
                                        onClick={() => this.handleSort('id', 'asc')}
                                        className="btn-link sort-down">
                                        <span className="kr kr-sorting-down" />
                                    </button>
                                    <button
                                        onClick={() => this.handleSort('id', 'desc')}
                                        className="btn-link sort-up">
                                        <span className="kr kr-sorting-up" />
                                    </button>
                                </div>
                            </div>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>
                            <CustomInputFilter
                                input_name="dentist_fullname"
                                focused={this.state.focusedField === 'dentist_fullname'}
                                focus={this.setFocusedField}
                                activeClassName="active-field"
                                inputClass="report__data__filter"
                                value={this.state.filterData.filterOptions.dentist_fullname}
                                blur={() => this.setFocusedField(null)}
                                placeholder=""
                                changeFilterOptions={this.filter}
                            />
                        </td>
                        <td>
                            <CustomInputFilter
                                input_name="patient_fullname"
                                focused={this.state.focusedField === 'patient_fullname'}
                                focus={this.setFocusedField}
                                activeClassName="active-field"
                                inputClass="report__data__filter"
                                value={this.state.filterData.filterOptions.patient_fullname}
                                blur={() => this.setFocusedField(null)}
                                placeholder=""
                                changeFilterOptions={this.filter}
                            />
                        </td>
                        <td>
                            <CustomInputFilter
                                input_name="id"
                                focused={this.state.focusedField === 'id'}
                                focus={this.setFocusedField}
                                activeClassName="active-field"
                                inputClass="report__data__filter"
                                value={this.state.filterData.filterOptions.id}
                                blur={() => this.setFocusedField(null)}
                                placeholder=""
                                changeFilterOptions={this.filter}
                            />
                        </td>
                    </tr>

                    {Object.keys(this.props.reportData.reports)
                        .sort((a, b) => (moment(a) - moment(b)))
                        .map((key) => {
                        const data = [];
                        data.push(
                            <tr className="tr-title" key={key}>
                                <td colSpan={8}>
                                    {moment(key, 'YYYY-MM-DD').format('DD MMMM dddd')} / Booked: {this.props.reportData.reports[key].number_of_units}
                                </td>
                            </tr>
                        );
                        data.push(this.props.reportData.reports[key].bookings
                            .map((item) => (
                            <Fragment>
                                <tr
                                    className={`${this.state.dropRowId === item.id ? "active-row" : ""}`}
                                    onClick={() => this.openDropRow(item.id)} key={item.id}
                                >
                                    <td>
                                        <span className="reports-value">
                                            {item.doctor}
                                        </span>
                                    </td>
                                    <td>
                                        <span className="reports-value">
                                            {item.patient}
                                        </span>
                                    </td>
                                    <td>
                                        <span className="reports-value">
                                            {item.id}
                                        </span>
                                    </td>
                                    <td>
                                        <span className="kr kr-arrow"/>
                                    </td>
                                </tr>
                                <tr className='dropdown_row'>
                                    {
                                        this.state.dropRowId === item.id &&
                                        <td colSpan={4}>
                                            <div className="reports__item">
                                                <span>Units</span>
                                                <span>{item.units}</span>
                                            </div>
                                            <div className="reports__item">
                                                <span>Type</span>
                                                <div className={`${item.type}-case case-type`}>
                                                    {item.type.charAt(0).toUpperCase() + item.type.slice(1)}
                                                </div>
                                            </div>
                                            <div className="reports__item">
                                                <span>Notes</span>
                                                <span className='admin-case-notes'>{item.admin_case_notes}</span>
                                            </div>
                                            <div className="reports__field">
                                                <div className="report__notes__column text-field">
                                                    <label>Appointment</label>
                                                    <input onBlur={(event) => this.handleBlur(event, item.id)}
                                                           className="report__notes__column__input text-field__input"
                                                           placeholder="Your appointment"
                                                           onClick={(e) => this.remainDefault(e)}
                                                           onChange={(e) => this.remainDefault(e)}
                                                           defaultValue={item.reportNotes || ''}
                                                    />
                                                </div>
                                            </div>
                                            <div className="reports__action">
                                                <button onClick={() => this.handleClickOnRow(item.id)}>
                                                    <span className="kr kr-edit"/>
                                                </button>

                                            </div>
                                        </td>
                                    }
                                </tr>
                            </Fragment>
                        )));
                        return data;
                    })}
                    </tbody>
                </table>
            )
        }

        return (
            <div className="view">
                <ViewHeader
                    header={header}
                    desc={desc}
                    showPrimary={false}
                    showSecondary={false}
                />
                <div className="view-content view-dashboard">
                    <div className="report-actions">
                        <div className="report-actions__block">
                            <span className="kr kr-refresh" data-tip="Sync" onClick={() => this.refreshReport()} />
                            <ReactTooltip place="top" type="light" effect="float" />
                            <div className="daily-reports-start-date datePicker-area-spaces">
                                <DatePicker
                                    selected={moment(this.state.filterData.filterOptions.startDate)}
                                    startDate={moment(this.state.filterData.filterOptions.startDate)}
                                    endDate={moment(this.state.filterData.filterOptions.endDate)}
                                    onChange={(date) => this.handleChangeStartDate(date)}
                                    placeholderText={moment().format('DD/MM/YYYY')}
                                    dateFormat="DD/MM/YYYY"/>
                                <span className="kr kr-calendar"/>
                            </div>
                            {this.state.isChecked ? <span className="hidden-md-down"> - </span> : ''}
                            {
                                (this.state.isChecked) ?
                                    <div className="daily-reports-end-date datePicker-area-spaces">
                                        <DatePicker
                                            selected={this.state.filterData.filterOptions.endDate && moment(this.state.filterData.filterOptions.endDate)}
                                            startDate={moment(this.state.filterData.filterOptions.startDate)}
                                            endDate={moment(this.state.filterData.filterOptions.endDate)}
                                            onChange={(date) => this.handleChangeEndDate(date)}
                                            placeholderText="Select Date"
                                            dateFormat="DD/MM/YYYY"
                                        />
                                        <span className="kr kr-calendar"/>
                                    </div>
                                    : ''
                            }

                            <div className="col-md-3 select-date-range-checkbox custom-control custom-checkbox">
                                <div className="checkbox custom-control custom-checkbox">
                                    <input
                                        id="date-range"
                                        type="checkbox"
                                        className="custom-control-input"
                                        name="type"
                                        checked={this.state.isChecked} onClick={() => this.handleClickCheckBox()}
                                    />
                                    <label htmlFor="date-range" className="checkbox-label custom-control-label">
                                        Select Date Range
                                    </label>
                                </div>
                            </div>

                        </div>
                        <div className="report-actions__block">
                            <ReactToPrint
                                trigger={() => <a type='button' className="btn btn-primary"><span className="kr kr-print" /> Print</a>}
                                content={() => this.componentRef}

                            />
                            <ViewToPrint ref={el => (this.componentRef = el)} reportData={this.props.reportData.allReports} />
                            <Dropdown className="" isOpen={this.state.dropdownOpen} toggle={() => this.toggle()}>
                                <DropdownToggle caret>
                                    Export As
                            </DropdownToggle>
                                <DropdownMenu right>
                                    <a onClick={() => this.handleExport('csv')}>CSV</a>
                                    <a onClick={() => this.handleExport('docx')}>DOCX</a>
                                    <a onClick={() => this.handleExport('pdf')}>PDF</a>
                                </DropdownMenu>
                            </Dropdown>
                        </div>
                    </div>
                    {
                        (this.props.reportData.loading) ?
                        <h1 className="text-center"><IconSpinner className="spinner" /> Loading...</h1>
                        :
                            <div className="view-card-block">
                                <div className="daily__cases">
                                    {
                                        navBig ? <table className="table table-display">
                                            <thead>
                                            <tr>
                                                <th style={{minWidth: '130px', width: '250px'}} className="header-position">
                                                    <div className="sorting">
                                                        <span className="th-name">Dentist</span>
                                                        <div className="sorting__icons">
                                                <button
                                                    onClick={() => this.handleSort('dentist_fullname', 'asc')}
                                                    className="btn-link sort-down">
                                                                <span className="kr kr-sorting-down" />
                                                </button>
                                                <button
                                                    onClick={() => this.handleSort('dentist_fullname', 'desc')}
                                                    className="btn-link sort-up">
                                                                <span className="kr kr-sorting-up" />
                                                            </button>
                                                        </div>
                                                    </div>
                                                </th>
                                                <th style={{minWidth: '130px', width: '250px'}} className="header-position">
                                                    <div className="sorting">
                                                        <span className="th-name">Patient</span>
                                                        <div className="sorting__icons">
                                                            <button
                                                                onClick={() => this.handleSort('patient_fullname', 'asc')}
                                                                className="btn-link sort-down">
                                                                <span className="kr kr-sorting-down" />
                                                </button>
                                                <button
                                                    onClick={() => this.handleSort('patient_fullname', 'desc')}
                                                    className="btn-link sort-up">
                                                                <span className="kr kr-sorting-up" />
                                                            </button>
                                                        </div>
                                                    </div>
                                                </th>
                                                <th style={{minWidth: '150px', width: '180px'}} className="header-position">
                                                    <div className="sorting">
                                                        <span className="th-name">Case ID</span>
                                                        <div className="sorting__icons">
                                                <button
                                                    onClick={() => this.handleSort('id', 'asc')}
                                                    className="btn-link sort-down">
                                                                <span className="kr kr-sorting-down" />
                                                </button>
                                                <button
                                                    onClick={() => this.handleSort('id', 'desc')}
                                                    className="btn-link sort-up">
                                                                <span className="kr kr-sorting-up" />
                                                            </button>
                                                        </div>
                                                    </div>
                                                </th>
                                                <th style={{minWidth: '150px', width: '180px'}} className="header-position">
                                                    <div className="sorting">
                                                        <span className="th-name">Units</span>
                                                        <div className="sorting__icons">
                                                            <button
                                                                onClick={() => this.handleSort('number_of_units', 'asc')}
                                                                className="btn-link sort-down">
                                                                <span className="kr kr-sorting-down" />
                                                </button>
                                                <button
                                                    onClick={() => this.handleSort('number_of_units', 'desc')}
                                                    className="btn-link sort-up">
                                                                <span className="kr kr-sorting-up" />
                                                            </button>
                                                        </div>
                                                    </div>
                                                </th>
                                                <th style={{minWidth: '145px', width: '180px'}} className="header-position">
                                                    <div className="sorting">
                                                        <span className="th-name">Type</span>
                                                        <div className="sorting__icons">
                                                            <button
                                                                onClick={() => this.handleSort('type', 'asc')}
                                                                className="btn-link sort-down">
                                                                <span className="kr kr-sorting-down" />
                                                            </button>
                                                            <button
                                                                onClick={() => this.handleSort('type', 'desc')}
                                                                className="btn-link sort-up">
                                                                            <span className="kr kr-sorting-up" />
                                                            </button>
                                                        </div>
                                                    </div>
                                                </th>
                                                <th style={{minWidth: '190px', width: '250px'}} className="header-position">
                                                    <span className="th-name">
                                                        Notes by Lab Admin
                                                    </span>
                                                </th>
                                                <th style={{minWidth: '190px', width: '250px'}} className="header-position">
                                                    <span className="th-name">
                                                        Status
                                                    </span>
                                                </th>
                                                <th style={{minWidth: '200px', width: '360px'}} className="header-position">
                                                    <span className="th-name">
                                                        Appointment
                                                    </span>
                                                </th>
                                                <th style={{width: '80px'}} className="header-position">
                                                    <span className="th-name">
                                                        Actions
                                                    </span>
                                                </th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr>
                                                <td><input className="report__data__filter" value={this.state.filterData.filterOptions.dentist_fullname}
                                                           onChange={(event) => this.handleFilter(event)} name="dentist_fullname"
                                                           type="text" placeholder='Search' /></td>
                                                <td><input className="report__data__filter" value={this.state.filterData.filterOptions.patient_fullname}
                                                           onChange={(event) => this.handleFilter(event)} name="patient_fullname"
                                                           type="text" placeholder='Search' /></td>
                                                <td><input className="report__data__filter" value={this.state.filterData.filterOptions.id}
                                                           onChange={(event) => this.handleFilter(event)} name="id"
                                                           type="number" placeholder='Search' /></td>
                                                <td><input className="report__data__filter" value={this.state.filterData.filterOptions.number_of_units}
                                                           onChange={(event) => this.handleFilter(event)} name="number_of_units"
                                                           type="number" placeholder='Search' /></td>
                                                <td>
                                                    <div className="fr-block">
                                                        <select className="filter__dropdown report__data__filter"
                                                                name="type"
                                                                onChange={(event) => this.handleFilter(event)}>
                                                            {this.state.typeFilter.map((type) => <option
                                                                key={type} value={type}
                                                                selected={this.state.filterData.filterOptions.type === type.toLowerCase()}>{type || 'Select Type'}</option>)}
                                                        </select>
                                                    </div>
                                                </td>
                                                <td></td>
                                                <td>
                                                    <div className="fr-block">
                                                        <select className="filter__dropdown report__data__filter"
                                                                name="status"
                                                                onChange={(event) => this.handleFilter(event)}>
                                                            {this.state.statusFilter.map((status) => <option
                                                                key={status} value={status}
                                                                selected={this.state.filterData.filterOptions.status === status.toLowerCase()}>{status || 'Select Status'}</option>)}
                                                        </select>
                                                    </div>
                                                </td>
                                            </tr>

                                            {Object.keys(this.props.reportData.reports).sort((a, b) => (moment(a) - moment(b))).map((key) => {
                                                const data = [];
                                                data.push(
                                                    <tr className="tr-title" key={key}>
                                                        <td colSpan={8}>
                                                            {moment(key, 'YYYY-MM-DD').format('DD MMMM dddd')} / Booked: {this.props.reportData.reports[key].number_of_units}
                                                        </td>
                                                    </tr>
                                                );
                                                data.push(this.props.reportData.reports[key].bookings.map((item) => {
                                                    return (
                                                        <tr key={item.id}>
                                                            <td>{item.doctor}</td>
                                                            <td>{item.patient}</td>
                                                            <td>{item.id}</td>
                                                            <td>{item.units}</td>
                                                            <td>
                                                                <div
                                                                    className={`${item.type}-case case-type`}>{item.type.charAt(0).toUpperCase() + item.type.slice(1)}</div>
                                                            </td>
                                                            <td>
                                                                <p
                                                                    style={{
                                                                        overflow: 'hidden',
                                                                        width: '180px',
                                                                        display: '-webkit-box',
                                                                        WebkitLineClamp: '3',
                                                                        WebkitBoxOrient: 'vertical'
                                                                    }}
                                                                    className='admin-case-notes'>{item.admin_case_notes}</p>
                                                            </td>
                                                            <td className='case_status'>{item.status}</td>
                                                            <td>
                                                                <div className="report__notes__column text-field">
                                                                    <input
                                                                        onBlur={(event) => this.handleBlur(event, item.id)}
                                                                        className="report__notes__column__input text-field__input"
                                                                        placeholder="Your appointment"
                                                                        onClick={(e) => this.remainDefault(e)}
                                                                        onChange={(e) => this.remainDefault(e)}
                                                                        defaultValue={item.reportNotes || ''}
                                                                    />
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <span className="kr kr-edit" data-tip="See case details"
                                                                      onClick={() => this.handleClickOnRow(item.id)}/>
                                                                <ReactTooltip place="top" type="light" effect="float"/>
                                                            </td>
                                                        </tr>
                                                    )
                                                }));
                                                return data;
                                            })}
                                            <tr>
                                                <td className='react-bs-table-no-data' colSpan='12' style={{background: '#f8f8f8'}}>
                                                    {this.props.reportData.totalCount < 1 && 'No data to display'}
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table> : mobileTableRender()
                            }
                                </div>
                                <Pagination
                                    locale={{ prev_page: 'prev', next_page: 'next'}}
                                    className="pagination__rc"
                                    showLessItems
                                    hideOnSinglePage={true}
                                    current={this.state.filterData.page}
                                    total={this.props.reportData.totalCount}
                                    pageSize={this.state.reportsPerPage}
                                    onChange={this.handlePageChange}
                                />
                            </div>
                    }
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    reportData: state.adminAllDailyReports,
    filterData: state.auth.filterData,
});

const mapDispatchToProps = dispatch => {
    return {
        getAllDailyReportData: (page, filterOptions, sortingOptions,getAllReports) => dispatch(getAllDailyReportData(page, filterOptions, sortingOptions,getAllReports)),
        getDailyReportData: (page, filterOptions, sortingOptions) => dispatch(getDailyReportData(page, filterOptions, sortingOptions)),
        updateReportNotes: (bookingId, reportNote) => dispatch(updateReportNotes(bookingId, reportNote)),
        exportDoc: (type, filterOptions) => dispatch(exportDoc(type, filterOptions))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(dailyReport);


// WEBPACK FOOTER //
// ./src/containers/Layouts/Admin/DailyReport/index.js